import { render, staticRenderFns } from "./DashboardSellers.vue?vue&type=template&id=f8efa1a4"
import script from "./DashboardSellers.vue?vue&type=script&lang=js"
export * from "./DashboardSellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports